// Utilities to manage "stay logged in" preference and Supabase auth token persistence
// Designed to follow SRP and be reused across auth-related components.

let cleanupInstalled = false
let beforeUnloadHandler: ((e: BeforeUnloadEvent) => void) | null = null

export const REMEMBER_KEY = 'auth:remember'

export function isRemembered(): boolean {
  try {
    return localStorage.getItem(REMEMBER_KEY) === '1'
  } catch {
    return false
  }
}

export function setRemembered(remember: boolean): void {
  try {
    if (remember) localStorage.setItem(REMEMBER_KEY, '1')
    else localStorage.removeItem(REMEMBER_KEY)
  } catch {
    // ignore storage errors (private mode, etc.)
  }
}

export function getSupabaseAuthStorageKey(): string | null {
  try {
    const url = (import.meta as any)?.env?.VITE_SUPABASE_URL as string | undefined
    if (!url) return null
    const host = new URL(url).host // e.g., abcd123.supabase.co
    const projectRef = host.split('.')[0]
    if (!projectRef) return null
    return `sb-${projectRef}-auth-token`
  } catch {
    return null
  }
}

export function removeSupabaseAuthFromLocalStorage() {
  try {
    const key = getSupabaseAuthStorageKey()
    if (key) localStorage.removeItem(key)
  } catch {
    // ignore
  }
}

export function installEphemeralSessionCleanup(): void {
  if (typeof window === 'undefined') return
  if (cleanupInstalled) return
  beforeUnloadHandler = () => {
    removeSupabaseAuthFromLocalStorage()
  }
  window.addEventListener('beforeunload', beforeUnloadHandler)
  cleanupInstalled = true
}

export function uninstallEphemeralSessionCleanup(): void {
  if (typeof window === 'undefined') return
  if (!cleanupInstalled) return
  if (beforeUnloadHandler) {
    window.removeEventListener('beforeunload', beforeUnloadHandler)
  }
  beforeUnloadHandler = null
  cleanupInstalled = false
}

export function ensureEphemeralPolicy(remember: boolean): void {
  if (remember) uninstallEphemeralSessionCleanup()
  else installEphemeralSessionCleanup()
}

